import React from 'react';

const AfterContent = ({ content }) => {
  return <></>;
};
export default AfterContent;
